import LinhaProduto from '@/pages/loja/components/LinhaProduto';
import type { ProdutoVitrine } from '../types';

interface Props {
  produto: ProdutoVitrine;
  qtd: number;
  previa?: boolean;
  aoMudarQtd: (produto: ProdutoVitrine, valor: number) => void;
}

function limiteMaximo(p: ProdutoVitrine): number {
  let limite = Number.MAX_SAFE_INTEGER;
  if (p.max_por_pedido != null && p.max_por_pedido > 0) limite = p.max_por_pedido;
  if (p.disponivel != null && p.disponivel >= 0) limite = Math.min(limite, p.disponivel);
  return limite;
}

// A ficha na vitrine usa a MESMA linha da loja pública (um componente só).
// Aqui só traduzimos o produto da vitrine para ela.
export default function LinhaFicha({ produto, qtd, previa, aoMudarQtd }: Props) {
  const esgotado = produto.situacao === 'esgotou';
  const travado = previa || esgotado;

  let etiqueta: string | null = null;
  if (esgotado) etiqueta = 'Esgotou';
  else if (produto.acabando) etiqueta = 'Últimas';
  else if (produto.so_para_inscritos) etiqueta = 'só inscritos';

  return (
    <LinhaProduto
      nome={produto.nome}
      descricao={produto.descricao}
      precoCentavos={produto.preco_centavos}
      imagemUrl={produto.imagem_url}
      imagemSlug={produto.imagem_slug}
      emoji={produto.emoji}
      quantidade={qtd}
      maximo={limiteMaximo(produto)}
      travado={travado}
      travadoRotulo={esgotado ? '—' : 'prévia'}
      etiqueta={etiqueta}
      aoMudarQuantidade={(valor) => aoMudarQtd(produto, valor)}
    />
  );
}